import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ConsultarCidadaoAutistaRequest, Types } from './types';

// ACTIONS
import {
	consultarCidadaoAutistaSuccess,
	consultarCidadaoAutistaFailure,
} from './actions';

function* consultarCidadaoAutista(request: ReducerActionRotaSP) {
	const token: string = yield select(state => state.user.token.data);
	const { payload }: { payload: ConsultarCidadaoAutistaRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		token,
		PATH_IIRGD_API,
		`cidadao-autista`,
		payload.query,
		undefined,
		undefined,
		undefined,
		payload.header,
	);

	if (response.status === 200) {
		yield put(consultarCidadaoAutistaSuccess(response));
	} else {
		yield put(consultarCidadaoAutistaFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTAR_CIDADAO_AUTISTA_REQUEST, consultarCidadaoAutista),
]);
